<template>
  <div>
    <div class="main-button-bar">
      <el-button type="primary" size="small" @click="showAddDialog">新增渠道</el-button>
    </div>

    <el-table
      :data="records"
      stripe
      style="width: 100%"
      :height="this.$tools.mainHeight() - 84"
      class="taobao-channel-table"
    >
      <el-table-column prop="name" label="渠道名称" width="200"></el-table-column>
      <el-table-column prop="shopName" label="所属店铺" width="200"></el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="channel">
          <el-tag type="success" v-if="channel.row.status == 'Y'">可用</el-tag>
          <el-tag type="danger" v-if="channel.row.status == 'N'">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="channel">
          <el-button
            v-if="channel.row.status == 'Y'"
            type="text"
            size="small"
            v-on:click="upstatus(channel.row.id, 'N')"
          >禁用</el-button>
          <el-button
            v-if="channel.row.status == 'N' || !channel.row.status"
            type="text"
            size="small"
            v-on:click="upstatus(channel.row.id, 'Y')"
          >启用</el-button>
          <el-button type="text" size="small" v-on:click="upname(channel.row.id)">修改名称</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="channel && channel.id ? '修改渠道' : '新增渠道'"
      :visible.sync="showDialog"
      width="500px"
    >
      <el-form ref="channel" :model="channel" label-width="80px" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="channel.name"></el-input>
        </el-form-item>

        <el-form-item label="所属店铺">
          <el-select v-model="channel.shopId" placeholder="请选择所属店铺（非必填）">
            <el-option v-for="item in shops" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" class="op-button" @click="doAdd">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDialog: false,
      records: null,
      shops: null,
      channel: {},
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 6 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    showAddDialog() {
      this.channel = {};
      this.showDialog = true;
    },
    doAdd() {
      let _this = this;

      _this.$http.post(
        ["taobao/channel/save", _this.channel],
        [
          function () {
            _this.showDialog = false;
            _this.channel = {};
            _this.list();
          },
        ],
        ".op-button"
      );
    },

    list() {
      let _this = this;

      _this.$http.post(
        ["taobao/channel/all"],
        [
          function (data) {
            _this.records = data;
          },
        ],
        ".taobao-stop-table"
      );
    },
    shop() {
      let _this = this;

      _this.$http.post(
        ["taobao/shop/valid"],
        [
          function (data) {
            _this.shops = data;
          },
        ],
        "none"
      );
    },

    upstatus(id, status) {
      this.channel.id = id;
      this.channel.status = status;
      this.doAdd();
    },

    upname(id) {
      let _this = this;

      _this.$tPrompt.show("输入新名称", function (data) {
        _this.channel.id = id;
        _this.channel.name = data;
        _this.doAdd();
      });
    },
  },
  mounted() {
    this.list();
    this.shop();
  },
};
</script>

<style lang="scss">
</style>